export const tourGuideSteps = [
  {
    selector: "#environment-name-header",
    content:
      "The environment friendly name with the identifier in parenthesis.",
  },
  {
    selector: "#use-default-threshold-values-button",
    content:
      "Press the button to apply the default threshold values to this environment.",
  },
  {
    selector: "#prune-frequency-options",
    content:
      "Enable pruning. Set the purning polling type and frequency.",
  },
  {
    selector: "#prune-window-options",
    content:
      "Set the pruning window.",
  },
  {
    selector: "#prune-events-options",
    content:
      "Enable pruning of events and the age of the events.",
  },
  {
    selector: "#update-mc-config-reset-button",
    content:
      "Press the button to revert changes above above to the original settings.",
  },
];
